import Api from "@/api/index";
import store from "@/store";
// import loading from "./loading";
import alerts from "@/components/alerts/alert";
import confirmations from "./confirmations";
import AuthenticationService from "@/services/AuthenticationService";
// import router from "@/router";

const students = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    queryParam: {},
    loading: false,
    modalCreate: false,
    studentKelas: [],
    modal: false,
    detail: null,
    modalDetail: false,
    modalUpload: false,
    activationData: null,
    activationModal: false,
    label: "Create",
    form: {},
    count: "0",
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
    count(state) {
      return state.count;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    SET_ACTIVATION_DATA(state, data) {
      state.activationData = data;
    },
    SET_ACTIVATION_MODAL(state, data) {
      state.activationModal = data;
    },
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_MODAL_CREATE(state, data) {
      state.modalCreate = data;
    },
    SET_MODAL_UPLOAD(state, data) {
      state.modalUpload = data;
    },
    SET_MODAL(state, data) {
      state.modal = data;
    },
    SET_DETAIL(state, data) {
      state.detail = data;
    },
    SET_MODAL_DETAIL(state, data) {
      state.modalDetail = data;
    },
    SET_STUDENT_CLASSES(state, data) {
      state.studentKelas = data;
    },
  },
  actions: {
    async getCount({ commit, state }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("students/count/all")
        .then(({ data }) => {
          state.count = data;
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          commit("SET_DATAS", error.data);
        });
    },
    ClearAll({ commit }, payload) {
      commit("SET_ALL", []);
    },
    openModalUpload({ commit }, payload) {
      commit("SET_MODAL_UPLOAD", true);
    },
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("students")
        .then(({ data }) => {
          commit("SET_ALL", data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
        });
    },
    async getStudentBySubjectId({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet(`students/subject/${payload}`)
        .then(({ data }) => {
          commit("SET_ALL", data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
        });
    },
    async getStudentByKelasId({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet(`students/classes/${payload}`)
        .then(({ data }) => {
          commit("SET_STUDENT_CLASSES", data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
        });
    },
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("students/page", payload).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
    async myStudentPaginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("students/my-student/page", payload).then(
        ({ data }) => {
          commit("SET_DATAS", data);
          commit("SET_LOADING", false);
        }
      );
    },
    onRefresh({ state }) {
      store.dispatch("students/paginate", state.queryParam);
    },
    onAction({ commit, state }, payload) {
      state.label = payload[1];
      if (payload[1] === "Create") {
        state.form = "";
        commit("SET_MODAL_CREATE", true);
      } else if (payload[1] === "Update") {
        state.form = payload[0];
        store.dispatch("regions/getRegency", state.form["province_id"]);
        store.dispatch("regions/getDistrict", state.form["regency_id"]);
        store.dispatch("regions/getVillage", state.form["district_id"]);
        commit("SET_MODAL_CREATE", true);
      } else if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      } else if (payload[1] === "Upload") {
        commit("SET_MODAL_UPLOAD", true);
      } else if (payload[1] === "Delete") {
        store.dispatch("students/confirmation", [
          payload[0],
          "Delete",
          "Apa anda yakin hapus : " + payload[0]["name"] + "?",
        ]);
      }
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(
        payload[0],
        `students/${payload[1]}`,
        payload[2] ? payload[2] : "Apa anda yakin ?"
      );
    },
    async Create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.postFormData("students", payload)
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("students/onRefresh");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async UploadExcel({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.post("students/upload-excel", {
        data: payload,
      })
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_UPLOAD", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("students/onRefresh");
        })
        .catch((error) => {
          console.log(JSON.stringify(error.response.data));
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
            store.dispatch(
              "errors/setValidCount",
              error.response.data.valid_count
            );
            store.dispatch(
              "errors/setInvalidCount",
              error.response.data.invalid_count
            );
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async Update({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.postFormData(
        "students/update/" + state.form.student_id,
        payload
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("students/onRefresh");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async Delete({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.delete(
        "students/" + payload.student_id
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("students/onRefresh");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    save({ state }, payload) {
      alerts.sweetalertToast("error", "Maaf... belum bisa di gunakan");
    },
    async fileSave({ commit, state }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPostFormData("sync/store/file", payload).then(
        ({ data }) => {
          commit("SET_DATAS", data);
          commit("SET_LOADING", false);
        }
      );
    },
    activation({ commit }, payload) {
      commit("SET_ACTIVATION_MODAL", true);
      commit("SET_ACTIVATION_DATA", payload);
    },
    async updateStatus({ commit }, payload) {
      return await AuthenticationService.put(
        `students/${payload.student_id}/activation`,
        payload
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
        })
        .catch((error) => {
          if (
            error.response.data.code === 409 ||
            error.response.data.code === 803
          ) {
            store.dispatch("students/onRefresh");
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async prosesActivation({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.put(
        `students/${payload.items.student_id}/activation`,
        payload
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          commit("SET_ACTIVATION_MODAL", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("students/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          if (
            error.response.data.code === 409 ||
            error.response.data.code === 803
          ) {
            store.dispatch("students/onRefresh");
          }
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
  },
};

export default students;
